import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../services/httpService';
import { ConfigService } from '../services/configService';
import { Vehicle } from '../components/verification-tractors-page/verification-tractors.model';
import { UserVerification } from '../components/verification-page/verification-page.model';
import { UserEmailConfirmationModel } from '../components/welcome-page/welcome-page.model';
import { ResetPasswordPageModel } from '../components/reset-password-page/reset-password-page.model';
import { Quote, QuoteByUserId } from '../models/quotes';

@Injectable()
export class UserService {
    private baseUrl: string;

    constructor(
        private http: HttpService,
        private config: ConfigService,
    ) {
        this.baseUrl = this.config.get('apiUrl') + '/v1';
    }

    public isEnrolled(): Observable<boolean> {
        return this.http.get(`${this.baseUrl}/quote/bound`);
    }

    public getQuoteByQnumQsuffix(qnum: number, qsuffix: string): Observable<Quote> {
        return this.http.get(`${this.baseUrl}/quote/${qnum}/${qsuffix}`);
    }

    public enroll() {
        return this.http.post(`${this.baseUrl}/quote/bound`, {});
    }
    
    public getQuote(): Observable<Quote> {
        return this.http.get(`${this.baseUrl}/quote`);
    }

    public getQuotes(): Observable<QuoteByUserId[]> {
        return this.http.get(`${this.baseUrl}/quotes`);
    }

    public confirmEmail(requestModel: UserEmailConfirmationModel): Observable<any> {
        return this.http.put(`${this.baseUrl}/user/password`, requestModel);
    }

    public forgotPassword(email: string): Observable<any> {
        return this.http.post(`${this.baseUrl}/user/password/reset-request`, {email});
    }

    public resetPassword(data: ResetPasswordPageModel): Observable<any> {
        return this.http.post(`${this.baseUrl}/user/password`, data);
    }

    public getUserVerificationInfo(): Observable<UserVerification> {
        return this.http.get(`${this.baseUrl}/user-verification`);
    }

    public getVehicles(qnum: number, qsuffix: string): Observable<Vehicle[]> {
        return this.http.get(`${this.baseUrl}/user/vehicles/${qnum}/${qsuffix}`);
    }
}